import React from "react";
import ERPUtils from "../../../helper/Utils";

const AdditionalInfoForm = (props) => {
  const { onChangeHandler, RenderData, roundData, ResearchDetailsHandler, ActiveInterviewRound, RequiedFields, interviewDetails } = props;
  let hide = [];
  return (
    <div className="parentBoxDiv border">
      <div className="boxheader withBorder ">
        <h3 id="headers">
          <b>Additional Information to online application</b>
        </h3>
      </div>
      <div>
        {ERPUtils.isUndefinedOrNull(RenderData) === false
          ? RenderData.map((els, id) => {
            els.detailsDTO.map((items) => {
              if (items.isDisplayInApplication === true) {
                if (ERPUtils.isUndefinedOrNull(hide[els.label]) || hide[els.label] === true) {
                  return (hide[els.label] = false);
                }
              } else {
                if (ERPUtils.isUndefinedOrNull(hide[els.label])) {
                  return (hide[els.label] = true);
                }
              }
              return "";
            });
            return "";
          })
          : null}
        {ERPUtils.isUndefinedOrNull(RenderData) === false && (interviewDetails.editable === false ? Object.keys(roundData.ResearchDetailsData).length > 0 : true)
          ? RenderData.map((el, index) => {
            if (el.isTypeResearch === false && el.employeeCategoryId === ActiveInterviewRound.empEmployeeCategoryId) {
              if (el.detailsDTO.length > 0) {
                let mainName = el.label;
                return (
                  <div key={index} className="border " >
                    {hide[el.label] === true ? null : (
                      <div className="ml-4">
                        <div className="row">
                          <div className="col-md-6 col-xs-12 ">
                            <label className="appFormLabel ResearchHeaders">{el.label}</label>
                          </div>
                        </div>
                      </div>
                    )}
                    {el.detailsDTO.map((item, idx) => {
                      let childName = item.label;
                      const researchDetailsValue = roundData?.ResearchDetailsData?.[mainName]?.[childName];
                      const valueLength = researchDetailsValue != null ? researchDetailsValue.length : null;
                      if (item.isDisplayInApplication === true) {
                        return (
                          <div key={idx} className="">
                            <div className="row  p-2">
                              <div className="col-md-5 col-xs-12 text-left">
                                <label className="appFormLabel ResearchSubHeaders ">{item.label}</label>
                              </div>
                              <div className="col-md-6 helperDiv text-right">
                                <textarea
                                  disabled={interviewDetails.editable === false ? true : false}
                                  className="form-control z-depth-3 resizeTextArea"
                                  rows="2"
                                  name={item.label}
                                  title={el.label}
                                  onChange={ResearchDetailsHandler}
                                  value={
                                    ERPUtils.isUndefinedOrNull(roundData.ResearchDetailsData) === false
                                      ? ERPUtils.isUndefinedOrNull(roundData.ResearchDetailsData[mainName]) === false
                                        ? ERPUtils.isUndefinedOrNull(roundData.ResearchDetailsData[mainName][childName]) === false
                                          ? roundData?.ResearchDetailsData[mainName][childName]
                                          : ""
                                        : ""
                                      : ""
                                  }
                                  maxLength={1000}
                                />
                                {valueLength != null ? `${valueLength} / 1000` : ""}
                              </div>
                            </div>
                          </div>
                        );
                      }
                      return "";
                    })}
                  </div>
                );
              }
            }
            return "";
          })
          : null}
      </div>

      {/* <div className="formWrapper">
				<div className="row">
					<div className="col-md-5" style={{ paddingLeft: '10px' }}>
						<label className="formExpLabel ">
							<span className="requiredText">*</span>
							Do you have UAN no?
						</label>
					</div>
					<div className="col-md-4" style={{ top: '13px' }}>
						<label className="radio-inline">
							<input
								className="space"
								onChange={onChangeHandler}
								type="radio"
								name="HaveUanNo"
								value="true"
								checked={roundData.HaveUanNo === 'true'}
								disabled={interviewDetails.editable === false ? true : false}
							/>
							Yes
						</label>
						<label className="radio-inline">
							<input
								className="space"
								onChange={onChangeHandler}
								type="radio"
								name="HaveUanNo"
								value="false"
								checked={roundData.HaveUanNo === 'false'}
								disabled={interviewDetails.editable === false ? true : false}
							/>
							No
						</label>
						{RequiedFields.HaveUanNoReqError ? (
							<p className="RoundValidationError">
								<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
							</p>
						) : null}
					</div>
				</div>
			</div > */}

      {/* {
				roundData.HaveUanNo === 'true' ? (
					<div className="formWrapper">
						<div className="row">
							<div className="col-md-5" style={{ paddingLeft: '10px' }}>
								<label className="formExpLabel ">
									<span className="requiredText">*</span>
									UAN
								</label>
							</div>
							<div className="col-md-4">
								<input
									className="form-control z-depth-3"
									onChange={onChangeHandler}
									value={roundData.UanNo}
									name="UanNo"
									type="text"
									maxLength="100"
									disabled={interviewDetails.editable === false ? true : false}
								/>
								{RequiedFields.UanNoReqError ? (
									<p className="RoundValidationError">
										<i className="fa fa-warning warningIcon" />&nbsp; This field cannot be empty
									</p>
								) : null}
							</div>
						</div>
					</div>
				) : null} */}
    </div>
  );
};

export default AdditionalInfoForm;
